import React, { useEffect, useState } from "react";
import { Navigate, Route, useLocation } from "react-router-dom";
import {setAuthorization} from "../helpers/api_helper";
import { useDispatch } from "react-redux";

import { useProfile } from "../Components/Hooks/UserHooks";
import {
  isOnboardingCompleted,
  refreshFeatureFlags,
} from "../helpers/feature_flags_helper";

import { logoutUser } from "../slices/thunks";

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { userProfile, loading, token } = useProfile();
  // Block child render until feature flags load once — prevents ModeGuard
  // from redirecting to /plans before the server tells us the user has
  // an active trial / paid plan.
  const [flagsReady, setFlagsReady] = useState(
    () => sessionStorage.getItem("featureFlagsLoaded") === "1"
  );
  useEffect(() => {
    if (userProfile && !loading && token) {
      setAuthorization(token);
      if (sessionStorage.getItem("featureFlagsLoaded") !== "1") {
        refreshFeatureFlags().finally(() => {
          sessionStorage.setItem("featureFlagsLoaded", "1");
          setFlagsReady(true);
        });
      } else {
        setFlagsReady(true);
      }
    } else if (!userProfile && loading && !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, loading, dispatch]);

  /*
    redirect is un-auth access protected routes via url
    */

  if (!userProfile && loading && !token) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }

  // Wait for first feature-flags resolve before rendering gated UI.
  if (token && userProfile && !flagsReady) {
    return null;
  }

  // LeadWix 2.0: force first-time users through onboarding wizard
  if (
    userProfile &&
    token &&
    !isOnboardingCompleted() &&
    location.pathname !== "/onboarding"
  ) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };